import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import AppContainer from './js/app/components/AppContainer';
import QueryDataContainer from './js/modules/querydata/components/QueryDataContainer';
import ErrorPageView from './js/common/components/ErrorPageView';
import NewUrlDialogBox from './js/common/components/NewUrlDialogBox';
import ErrorBoxView from './js/common/components/ErrorBoxView';
import store from './js/store/StoreConfigure';
import './assets/sass/styles.scss';
import './assets/sass/themes/default/default_theme.scss';
import AppHelper from 'js/app/AppHelper';
import properties, { setProperties } from 'properties';
import AppUtil, { setAppStore } from 'js/utils/AppUtil';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import './i18n';
import versionInfo from 'VersionInfo';

setAppStore(store);

AppHelper.setParamMap();

const loadProperties = callbackFn => {
    AppUtil.ajax( AppUtil.processURLForAppContextPath("data/AppProps.json"), undefined, response => {
        setProperties(response);

        const loadCntStyle = {
            height: '100%',
            width: '100%',
            textAlign: 'center',
            position: 'absolute',
            top: '0px',
            left: '0px'
        }
        const loadImgStyle = {
            height: '100px',
            width: '100px',
            position: 'relative',
            top: '50%',
            transform: 'translateY(-50%)'
        }

        ReactDOM.render((
            <div style={ loadCntStyle }>
                <img src={ AppUtil.processURLForAppContextPath('svg/loading.svg') } alt='Loading' style={ loadImgStyle }></img>
            </div>
        ) , document.getElementById('root'));

        callbackFn();
    });
}

const generateToken = callbackFn => {
    const w_url = properties.isIntegrated ? properties.url + "login" : "ewrf/data/AppConfig.json";
    
    AppUtil.ajax( w_url, {
        enterpriseId: AppHelper.getParamData('icentid'),
        loginID: AppHelper.getParamData('icentid') + '_admin',
        password: properties.authTokenKey
    }, result => {
        AppHelper.setAppAppAuthToken( result.headers.get('Authorization') );

        callbackFn();        
    }, () => {
        ReactDOM.render(<ErrorPageView /> , document.getElementById('root'));
    }, true );
}

const paintApplication = () => {
    let contextpath = '/issuecollector';
    
    if ( properties.contextPath && properties.contextPath !== '' && properties.contextPath !== '#CONTEXTPATH#' ) {
        contextpath = '/' + properties.contextPath;
    }

    if ( AppHelper.getParamData('querydata') === 'Y' ) {
        ReactDOM.render((
            <Provider store={ store }>
                <Router>
                    <Switch>
                        <Route path={ contextpath }>
                            <QueryDataContainer store={ store }/>
                        </Route>
                    </Switch>
                </Router>
            </Provider>)
        , document.getElementById('root'));
    } else {
        const w_url = properties.isIntegrated && window.location.href.indexOf('/querydata') === -1
            ? properties.url + APP_URL_CONSTANTS.GET_CONFIG + "/" + AppHelper.getParamData('icentid') + 
            "/" + AppHelper.getParamData('sointprjid') + "/" + AppHelper.getParamData('soextprjid').replace(/\//g, "EWREscalatedSlash") +
            "/" + AppHelper.getParamData('sologinid'): "ewrf/data/AppConfig.json";
    
        const w_param = {
            'soexturid': AppHelper.getParamData('soexturid') && AppHelper.getParamData('soexturid').includes("#") ? encodeURIComponent(AppHelper.getParamData('soexturid')) : AppHelper.getParamData('soexturid'),
            'sologinid': AppHelper.getParamData('sologinid'),
            'sointusrid': encodeURIComponent(AppHelper.getParamData('sointusrid'))
        }

        AppUtil.ajax( w_url, w_param, responseConfig => {
            const sourceVersionNumber = AppHelper.getParamData('currentbuildversion');
           const currentVersionSplit = sourceVersionNumber ? sourceVersionNumber.split(".") : [];
            const supportedVersionNumber = responseConfig && responseConfig.versionInfo ? 
                responseConfig.versionInfo.sourcesupporttedversion[responseConfig.enterpriseType].split('.') : undefined;

            if ( sourceVersionNumber && supportedVersionNumber ) {
                currentVersionSplit[0] = parseInt(currentVersionSplit[0].replace(/%20/g, '').match(/\d/g).join(''));
                currentVersionSplit[1] = parseInt(currentVersionSplit[1]);
                supportedVersionNumber[0] = parseInt(supportedVersionNumber[0]);
                supportedVersionNumber[1] = parseInt(supportedVersionNumber[1]);
            }

            const w_validVersion = supportedVersionNumber ? (currentVersionSplit[0] > supportedVersionNumber[0]
                ? true : currentVersionSplit[0] === supportedVersionNumber[0] ? currentVersionSplit[1] >= supportedVersionNumber[1]: false) : false

            if ( responseConfig.m_errorList ) {
                ReactDOM.render(<ErrorBoxView dataHtml={ AppUtil.processErrorMessage( responseConfig.m_errorList[0] ) }/> , document.getElementById('root'));
            } else if ( properties.isIntegrated && sourceVersionNumber && !w_validVersion) {
                const supportVersionMsg = `For External Work Requests to work product version should be equal to ${responseConfig.versionInfo.sourcesupporttedversion[responseConfig.enterpriseType]} or above`;

                ReactDOM.render(<ErrorBoxView dataHtml={ supportVersionMsg }/> , document.getElementById('root'));
            } else {
                AppHelper.initConfig( responseConfig );

                if ( responseConfig.customCSSFiles ) {
                    AppHelper.loadCustomCSSFiles( responseConfig.customCSSFiles );
                }

                if ( properties.isIntegrated ) {
                    const w_cardASyncURL = properties.url + APP_URL_CONSTANTS.SYNC_CARD_TYPES + "/" + AppHelper.getParamData('icentid') + 
                        "/" + AppHelper.getParamData('sointprjid') + "/" + AppHelper.getParamData('soextprjid').replace(/\//g, "EWREscalatedSlash") +
                        "/" + AppHelper.getAppData('projectId') + "/" + AppHelper.getAppData('user_data').id + "/" +
                        AppHelper.getParamData('sologinid');

                    AppUtil.ajax( w_cardASyncURL, undefined, undefined, undefined, false, undefined, false);
                }

                ReactDOM.render((
                    <Provider store={ store }>
                        <Router>
                            <Switch>
                                <Route path={ contextpath }>
                                    <AppContainer store={ store }/>
                                </Route>
                            </Switch>
                        </Router>
                    </Provider>)
                , document.getElementById('root'));
            }
        }, undefined, false, properties.isIntegrated && window.location.href.indexOf('/querydata') === -1 ? {
            method: 'POST'
        } : undefined )
    }
}

const initApplication = () => {
    if ( AppHelper.getParamData('icentid') ) {
        loadProperties(() => {
            generateToken(() => {
                paintApplication();
            });
        })
    } else {
        window.addEventListener("message", messageConfig => {
            if ( messageConfig && messageConfig.data && messageConfig.data.AppEntID ) {
                AppHelper.addInParamMap({
                    icentid: messageConfig.data.AppEntID
                });
    
                AppHelper.setAppAppAuthToken( messageConfig.data.AppToken );
                
                if ( messageConfig.data.customThemeFile ) {
                    AppHelper.loadCustomCSSFiles( [messageConfig.data.customThemeFile] );
                }

                if ( messageConfig.data.whatFixConfig ) {
                    AppHelper.setWhatFixScriptInFrameHead(messageConfig.data.whatFixConfig);
                }
        
                loadProperties(() => {
                    paintApplication();
                });
            }
        });
    }
}


if ( window.location.href.indexOf('/form?') > -1 || AppHelper.getParamData('icForm') === 'Y' ) {
    loadProperties(() => {
        const contextpath = '/form';
        const ewrfContextpath = '/'+properties.contextPath + '/form';
        const w_url = properties.url + APP_URL_CONSTANTS.GET_ENTERPRISE_DATA_FROM_IC_ID_URL + "/" + AppHelper.getParamData('collectorid');

        AppUtil.ajax( w_url, undefined, enterpriseData => {
            AppHelper.addInParamMap({
                icentid: enterpriseData.id
            });

            AppHelper.addInParamMap({
                issuecollectordataurl: enterpriseData.issuecollectordataurl
            });

            let browserUrl = window.location.href, url = window.location.origin;
            let enterpriseEwrUrl = properties.enterpriseEwrUrl ? JSON.parse(properties.enterpriseEwrUrl.replace(/'/g, '"')) : {};
            enterpriseEwrUrl = enterpriseEwrUrl[enterpriseData.id] ?? url;

            if(url !== enterpriseEwrUrl) {
                AppUtil.loadCustomCSSFiles(['fonts/fonts-loader.css?RN=' + versionInfo.version]);
                browserUrl = browserUrl.replace(/(https?:\/\/[^/]+\.com)/, enterpriseEwrUrl);
                ReactDOM.render(<NewUrlDialogBox url={browserUrl} /> , document.getElementById('root'));
            }  else {
            generateToken(() => {
                ReactDOM.render((
                    <Provider store={ store }>
                            <Router>
                                <Switch>
                                    <Route path={ contextpath }>
                                        <AppContainer store={ store } openForm={ true }/>
                                    </Route>
                                    <Route path={ ewrfContextpath }>
                                        <AppContainer store={ store } openForm={ true }/>
                                    </Route>
                                </Switch>
                            </Router>
                    </Provider>
                ) , document.getElementById('root'));
            });
        }
        },
        () => {
            ReactDOM.render(<ErrorPageView /> , document.getElementById('root'));
        });

    })
} else {
    initApplication();
}

serviceWorker.unregister();